module.exports = __webpack_public_path__ + "components/flag/static/square/ss-52a5d2f35b7fbd69f1af6b50806d1bbe.svg";